import React, { ForwardedRef } from 'react';
export default React.forwardRef(
  ({ type = '', icon = '', size = '', className = '' }: any, ref: ForwardedRef<HTMLElement>) => {
    return (
      <>
        <i ref={ref} className={`ki-duotone ${icon} ${size} text-${type} ${className}`}>
          <span className="path1" />
          <span className="path2" />
          <span className="path3" />
          <span className="path4" />
          <span className="path5" />
          <span className="path6" />
          <span className="path7" />
          <span className="path8" />
          <span className="path9" />
          <span className="path10" />
        </i>
      </>
    );
  }
);
